//EXTERNAL
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
//COMPONENTS
import Article from "../components/Article";
import Header from "../components/Header";
import AdSlot from "../components/AdSlot";
//ASSETS
import PicnicLogo from "../assets/picnic-logo-white.png";
//FUNCTIONS

export default function Manual({ isDesktop }) {
  const path = "https://ads.picnic-media.com/";
  const location = useLocation();
  const pathname = location.pathname.split("/");
  const adSlotSize = pathname[2];
  const creativeId = pathname[3];
  const [adSlotWidth, setAdSlotWidth] = useState(null);
  const [adSlotHeight, setAdSlotHeight] = useState(null);

  useEffect(() => {
    async function setSizes() {
      setAdSlotWidth(adSlotSize.split("x")[0]);
      setAdSlotHeight(adSlotSize.split("x")[1]);
    }
    setSizes();
  }, [adSlotSize]);

  function buildAdSlot() {
    return (
      <>
        {adSlotWidth !== null ? (
          <>
            <AdSlot path={buildPath()} id={creativeId} width={adSlotWidth} height={adSlotHeight} />
          </>
        ) : null}
      </>
    );
  }

  function buildPath() {
    return path + creativeId;
  }

  return (
    <div className="bg-pink">
      {isDesktop ? (
        <>
          <Header Logo={PicnicLogo} />
        </>
      ) : null}
      <Article isDesktop={isDesktop} format={buildAdSlot()} />
    </div>
  );
}
